import { createContext, useContext } from "react";
import type { Map } from "leaflet";

type MapContextType = {
  map: Map | null;
  setMap: (map: Map) => void;
};

export const MapContext = createContext<MapContextType | null>(null);

export const useLeafletMap = () => {
  const ctx = useContext(MapContext);
  if (!ctx)
    throw new Error("useLeafletMap must be used within <MapContext.Provider>");
  return ctx;
};
